export default "__VITE_ASSET__CZ5tqQ71__"